import { render, staticRenderFns } from "./customCheckBox.vue?vue&type=template&id=01295384&scoped=true"
import script from "./customCheckBox.vue?vue&type=script&lang=js"
export * from "./customCheckBox.vue?vue&type=script&lang=js"
import style0 from "./customCheckBox.vue?vue&type=style&index=0&id=01295384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01295384",
  null
  
)

export default component.exports